document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[data-variants]');
  if (!form) return;

  // Parse the minimal variant data from data attributes
  const variantIds = JSON.parse(form.dataset.variants);
  const variantOptions = JSON.parse(form.dataset.options);
  // Obtener información de disponibilidad de las variantes
  const variantAvailability = {};
  if (window.product && window.product.variants) {
    window.product.variants.forEach(function(variant) {
      variantAvailability[variant.id] = variant.available;
    });
  }
  // Only select radio inputs for this product's options
  const optionInputs = document.querySelectorAll('input[type=radio][name^="option-"]');
  const addToCartBtn = form.querySelector('.add-to-cart');

  function updateVariantId() {
    const selectedOptions = [];
    const optionGroups = form.querySelectorAll('.product-option');
    optionGroups.forEach((group) => {
      const checked = group.querySelector('input[type=radio]:checked');
      if (checked) {
        selectedOptions.push(checked.value);
      }
    });
    // Find the matching variant index
    const matchingVariantIndex = variantOptions.findIndex(function (variantOpts) {
      return variantOpts.every(function (opt, index) {
        return opt === selectedOptions[index];
      });
    });
    if (matchingVariantIndex !== -1) {
      const variantInput = document.getElementById('product-variant-id');
      if (variantInput) {
        variantInput.value = variantIds[matchingVariantIndex];
      }
      // Comprobar disponibilidad y actualizar clase del botón
      const variantId = variantIds[matchingVariantIndex];
      if (addToCartBtn) {
        if (variantAvailability[variantId] === false) {
          addToCartBtn.classList.add('sold-out');
          addToCartBtn.textContent = 'Sold out';
        } else {
          addToCartBtn.classList.remove('sold-out');
          addToCartBtn.textContent = 'Add to cart';
        }
      }
    }
  }

  optionInputs.forEach(function (input) {
    input.addEventListener('change', updateVariantId);
  });

  updateVariantId();

  const slidesCount = document.querySelectorAll('#product-imagery .swiper-slide').length;
  const isDesktop = window.innerWidth >= 820;
  const shouldLoop = isDesktop ? slidesCount > 3 : true;

  const productSwiper = new Swiper('#product-imagery', {
    direction: 'horizontal',
    loop: shouldLoop,
    slidesPerView: 1,
    grabCursor: true,
    breakpoints: {
      820: {
        slidesPerView: 2.8,
        mousewheel: {
          enabled: true,
          forceToAxis: true
        },
      }
    },
  });
});